import axios from 'axios';

const client = axios.create({
    withCredentials: true,
});

async function bootstrap(props = {}) {
    const { data } = await client.post('bootstrap', props);
    if (!data.success) {
        return null;
    }
    return data.psdata;
}

async function login(props) {
    const { data } = await client.post('login', props);
    return data;
}

async function logout(props = {}) {
    const { data } = await client.post('logout', props);
    return data;
}

async function register(props) {
    const { data } = await client.post('register', props);
    return data;
}

function transformProducts(data) {
    return {
        ...data,
        title: data.name,
        totalProducts: data.pagination.total_items,
        products: data.products.map((product) => transformProduct(product)),
    };
}
function transformProduct(product) {
    return {
        id: product?.id_product,
        name: product?.name,
        slug: product?.link_rewrite,
        sku: product?.sku,
        description: product?.description,
        variants: [],
        gallery: [],
        quantityLimit: product?.quantity,
        rating: {
            average: 0,
            count: 0,
        },
        attributes: [],
        price: {
            isDiscounted: product?.has_discount,
            regularPrice: product?.regular_price,
            value: product?.price,
        },
        primaryImage: {
            url: product?.default_image?.url,
            alt: product?.name,
        },
    };
}

async function getProducts(params) {
    const { data } = await client.post('getProducts', {
        id_category: params.id_category,
        categorySlug: params.categorySlug,
        page: params.page || 1,
        q: params.q || '',
        with_category_tree: true,
        order: params.order,
    });
    return data.psdata;
}
async function getRelatedProducts(params) {
    const { data } = await client.post('getRelatedProducts', {
        id_product: params.id_product,
        page: params.page || 1,
    });
    return data.psdata;
}
async function getProduct(props) {
    let params = {
        product_id: props.id,
    };
    if (props.groupId && props.attributeId) {
        params = {
            product_id: props.id,
            group: {
                [props.groupId]: props.attributeId,
            },
        };
    }
    const { data } = await client.post('getProduct', params);
    if (!data.success) {
        return null;
    }
    return data.psdata;
}
async function getProductRecommended(props) {
    const { data } = await client.post('getProducts', {
        id_category: 10,
        categorySlug: 'clothing',
        page: 1,
    });
    return transformProducts(data.psdata);
}
async function getProductsFeatured(params = {}) {
    const { data } = await client.post('getProductsFeatured', params);
    return (data.psdata ?? {
        products: [],
    });
}
async function getProductsBestsellers(params = {}) {
    const { data } = await client.post('getProductsBestsellers', params);
    return (data.psdata ?? {
        products: [],
    });
}
async function getProductsLatest(params = {}) {
    const { data } = await client.post('getProductsLatest', params);
    return (data.psdata ?? {
        products: [],
    });
}
async function getProductReviews(params) {
    const { data } = await client.post('getProductReviews', {
        productId: params.productId
    });
    return data.psdata;
}
async function createProductReview(params) {
    const { data } = await client.post('createProductReview', {
        productId: params.productId,
        review: params.review
    });
    return data.psdata;
}
async function updateProductReview(params) {
    const { data } = await client.post('updateProductReview', {
        productId: params.productId,
        reviewId: params.reviewId,
        review: params.review
    });
    return data.psdata;
}
async function deleteProductReview(params) {
    const { data } = await client.post('deleteProductReview', {
        productId: params.productId,
        reviewId: params.reviewId
    });
    return data.psdata;
}

async function getShippingMethods() {
    const { data } = await client.post('getCarriers', {});
    return data.psdata;
}
async function getCollectionPoints(params) {
    const { data } = await client.post('getPudos', params);
    return data;
}

async function getCountries(params = {}) {
    const { data } = await client.post('getCountries', params);
    if (!data.success) {
        return [];
    }
    return data.psdata || { countries: [], groups: {} };
}
async function getCountry(params) {
    const { data } = await client.post('getCountry', params);
    return data.psdata || null;
}

async function getBrands(props = {}) {
    const { data } = await client.post('getBrands', props);
    return data.psdata;
}
async function getBrand(props = {}) {
    const { data } = await client.post('getBrand', props);
    return data.psdata;
}

async function getContent(props) {
    return null;
}

async function getCheckout(props) {
    const { data } = await client.post('getCheckout', {
        ...props,
    });
    if (!data.success) {
        return data;
    }
    return data.psdata;
}

async function getAddresses() {
    const { data } = await client.post('getAddresses');
    if (!data.success) {
        return null;
    }
    return data.psdata;
}

async function getCustomer() {
    const { data } = await client.post('getCustomer', {});
    if (!data.success) {
        return null;
    }
    return data.psdata;
}
async function updateCustomer(props) {
    const { data } = await client.post('updateCustomer', props.customer);
    return data;
}

async function getCategory(params) {
    const { data } = await client.post('getCategory', {
        ...params
    });
    return data.psdata;
}

async function orderGet(props) {
    const { data } = await client.post('getOrder', props);
    return data.psdata;
}
async function orderCreate(props) {
    const { data } = await client.post('createOrder', props);
    return data;
}
async function orderGetAll(props) {
    const { data } = await client.post('getOrders', props);
    return data.psdata;
}
async function orderValidate(props) {
    try {
        const { data } = await client.post('validateOrder', props);
        return data;
    }
    catch (e) {
        console.log(e);
    }
    return null;
}
async function orderUpdate(props) {
    const { data } = await client.post('updateOrder', props);
    return data;
}

async function getCartItems(props = null) {
    const { data } = await client.post('getCartItems', props);
    if (!data.success) {
        return data.message;
    }
    return data.psdata;
}
async function createCartItem(props) {
    const { data } = await client.post('createCartItem', props);
    if (!data.success) {
        return data;
    }
    return data.psdata;
}
async function updateCartItem(props) {
    const { data } = await client.post('updateCartItem', props);
    if (!data.success) {
        return data;
    }
    return data.psdata;
}
async function removeCartItem(props) {
    const { data } = await client.post('removeCartItem', props);
    if (!data.success) {
        return data;
    }
    return data.psdata;
}
async function addOrRemoveCoupon(props) {
    const { data } = await client.post('addOrRemoveCoupon', props);
    if (!data.success) {
        return data;
    }
    return data.psdata;
}

async function search(props, config) {
    const { data } = await client.post('search', {
        ...props,
    }, config);
    return data?.psdata;
}

async function resetPasswordEmail(props) {
    const { data } = await client.post('resetPasswordEmail', {
        email: props.email,
    });
    return data;
}
async function resetPasswordEnter(props) {
    const { data } = await client.post('resetPasswordEnter', {
        ...props
    });
    return data;
}

async function getGateways(props = {}) {
    const { data } = await client.post('getGateways', {
        ...props,
    });
    if (!data.success) {
        return data;
    }
    return data.psdata;
}

async function updateCheckoutAddress(props) {
    const { data } = await client.post('updateCheckoutAddress', {
        ...props,
    });
    if (!data.success) {
        return data;
    }
    return data.psdata;
}

async function updateCheckoutCarrier(props) {
    const { data } = await client.post('updateCheckoutCarrier', {
        ...props,
    });
    if (!data.success) {
        return data;
    }
    return data.psdata;
}

async function updateAddress(props) {
    const { data } = await client.post('updateAddress', props.address);
    return data;
}

async function removeAddress(props) {
    const { data } = await client.post('removeAddress', props);
    if (!data.success) {
        return null;
    }
    return data;
}

async function createAddress(props) {
    const { data } = await client.post('createAddress', props.address);
    return data;
}

async function getOrders() {
    const { data } = await client.post('getOrders');
    if (!data.success) {
        return null;
    }
    return data.psdata;
}

async function getOrder(props) {
    const { data } = await client.post('getOrder', props);
    if (!data.success) {
        return null;
    }
    return data.psdata;
}

async function addOrEditDeliveryMessage(props) {
    const { data } = await client.post('addOrEditDeliveryMessage', { ...props });
    return data.psdata;
}
async function getDeliveryMessage() {
    const { data } = await client.get('getDeliveryMessage');
    return data.psdata;
}

var methods = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addOrEditDeliveryMessage: addOrEditDeliveryMessage,
    addOrRemoveCoupon: addOrRemoveCoupon,
    bootstrap: bootstrap,
    createAddress: createAddress,
    createCartItem: createCartItem,
    createProductReview: createProductReview,
    deleteProductReview: deleteProductReview,
    getAddresses: getAddresses,
    getBrand: getBrand,
    getBrands: getBrands,
    getCartItems: getCartItems,
    getCategory: getCategory,
    getCheckout: getCheckout,
    getCollectionPoints: getCollectionPoints,
    getContent: getContent,
    getCountries: getCountries,
    getCountry: getCountry,
    getCustomer: getCustomer,
    getDeliveryMessage: getDeliveryMessage,
    getGateways: getGateways,
    getOrder: getOrder,
    getOrders: getOrders,
    getProduct: getProduct,
    getProductRecommended: getProductRecommended,
    getProductReviews: getProductReviews,
    getProducts: getProducts,
    getProductsBestsellers: getProductsBestsellers,
    getProductsFeatured: getProductsFeatured,
    getProductsLatest: getProductsLatest,
    getRelatedProducts: getRelatedProducts,
    getShippingMethods: getShippingMethods,
    login: login,
    logout: logout,
    orderCreate: orderCreate,
    orderGet: orderGet,
    orderGetAll: orderGetAll,
    orderUpdate: orderUpdate,
    orderValidate: orderValidate,
    register: register,
    removeAddress: removeAddress,
    removeCartItem: removeCartItem,
    resetPasswordEmail: resetPasswordEmail,
    resetPasswordEnter: resetPasswordEnter,
    search: search,
    updateAddress: updateAddress,
    updateCartItem: updateCartItem,
    updateCheckoutAddress: updateCheckoutAddress,
    updateCheckoutCarrier: updateCheckoutCarrier,
    updateCustomer: updateCustomer,
    updateProductReview: updateProductReview
});

/**
 * Initialize the Prestashop connector.
 */
const prestashopConnector = (options) => {
    client.defaults.baseURL = options.apiUrl;
    client.defaults.headers.common = options.headers;
    return methods;
};

/**
 * Prestashop module.
 */
const prestashopModule = (options) => ({
    connector: prestashopConnector({
        apiUrl: options.apiUrl,
        headers: options.headers,
    }),
    utils: {},
    subscribers: {},
});

export { client, prestashopModule };
